import { render } from "./motion-select-area.vue?vue&type=template&id=57006849"
import script from "./motion-select-area.vue?vue&type=script&lang=js"
export * from "./motion-select-area.vue?vue&type=script&lang=js"

import "./motion-select-area.vue?vue&type=style&index=0&id=57006849&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__